import {
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableRow,
  Theme,
} from '@mui/material'
import Paper from '@mui/material/Paper'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import React from 'react'
import { Profile } from '../../../../Profile/types'
import { UnitMaster } from '../../../../Units/reducer'

const SXCell = {
  borderRight: (theme: Theme) => `1px solid ${theme.palette.divider}`,
  width: 120,
}

interface Props {
  profile: Profile
  options: UnitMaster[]
  onChangeUnit: (val: UnitMaster | null) => void
  unit: UnitMaster | null
  isUnitToBeCancelled: boolean
  isSubmittingChange: boolean
}

export const AdminIndividualUnitTable: React.FC<Props> = ({
  profile,
  options,
  onChangeUnit,
  unit,
  isUnitToBeCancelled,
  isSubmittingChange,
}) => (
  <TableContainer component={Paper}>
    <Table
      sx={{
        border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
      }}
      size="small"
    >
      <TableBody>
        <TableRow>
          <TableCell align="right" sx={SXCell}>
            Customer:
          </TableCell>
          <TableCell>{profile.fullName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={SXCell} align="right">
            Email:
          </TableCell>
          <TableCell>{profile.email}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={SXCell} align="right">
            Phone:
          </TableCell>
          <TableCell>{profile.phoneNumber}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={SXCell} align="right">
            Address:
          </TableCell>
          <TableCell>{`${profile.address} ${profile.city} ${profile.state} ${profile.zip}`}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{
              ...SXCell,
              ...{
                color: isUnitToBeCancelled
                  ? (theme: Theme) => theme.palette.grey[600]
                  : undefined,
              },
            }}
            align="right"
          >
            Unit:
          </TableCell>
          <TableCell
            sx={{
              padding: '0px !important',
              '& .MuiInputBase-root': {
                width: 80,
                fieldset: {
                  display: 'none',
                },
                '& .MuiSvgIcon-root': {
                  fill: (theme: Theme) =>
                    isUnitToBeCancelled
                      ? theme.palette.grey[600]
                      : theme.palette.primary.dark,
                },
                '& .MuiOutlinedInput-input': {
                  padding: '2.5px 14px !important',
                  color: (theme: Theme) => theme.palette.primary.dark,
                },
              },
            }}
          >
            <Select
              disabled={isUnitToBeCancelled || isSubmittingChange}
              value={unit?.id}
              onChange={(event: SelectChangeEvent) => {
                const _id = event.target.value
                const obj = options.find((o) => o.id === _id)
                if (obj != null) {
                  onChangeUnit(obj)
                }
              }}
              sx={{
                '& .MuiInputBase-root': {
                  fieldset: {
                    display: 'none',
                  },
                },
                '& .Mui-disabled': {
                  WebkitTextFillColor: (theme: Theme) =>
                    theme.palette.grey[600],
                  opacity: 1,
                },
              }}
            >
              {options.map((o) => (
                <MenuItem key={o.id} value={o.id}>
                  {o.unitNumber}
                </MenuItem>
              ))}
            </Select>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
)
